export default "__VITE_ASSET__I2gHiswe__"